export const pages = {
    home: { path: "/", label: "Home" },
    classes: { path: "/classes", label: "Classes" },
    wheelFoundations: { path: "/classes/wheel-foundations", label: "Wheel Foundations" },
    handbuiltForms: { path: "/classes/handbuilt-forms", label: "Handbuilt Forms" },
    surfaceStories: { path: "/classes/surface-stories", label: "Surface Stories" },
    openGlazeLab: { path: "/classes/open-glaze-lab", label: "Open Glaze Lab" },
    book: { path: "/book", label: "Book a Class" },
    staff: { path: "/staff", label: "Staff Bookings" },
};
export function routeLocationSnapshot(location) {
    return JSON.stringify([location.pathname, location.search]);
}
export function routeLocationFromSnapshot(snapshot) {
    const [pathname, search] = JSON.parse(snapshot);
    return { pathname, search };
}
/**
 * Bridges the host's popstate lifecycle into React's external-store contract.
 * Reading on every snapshot request also makes the first render truthful for a
 * direct route, while the serialized pathname + search pair detects search-only
 * navigation as well as ordinary back/forward route changes.
 */
export function createRouteLocationStore(source) {
    let snapshot = routeLocationSnapshot(source.read());
    return {
        getSnapshot: () => {
            const nextSnapshot = routeLocationSnapshot(source.read());
            if (nextSnapshot !== snapshot)
                snapshot = nextSnapshot;
            return snapshot;
        },
        subscribe: (listener) => source.listen(listener),
    };
}
const ROUTE_SEGMENTS = ["classes", "book", "staff"];
function isRouteSegment(value) {
    return ROUTE_SEGMENTS.some((segment) => segment === value);
}
function routeSegment(pathname) {
    return pathname.replace(/\/$/, "").split("/").pop()?.toLowerCase() ?? "";
}
function pathSegments(pathname) {
    return pathname.replace(/\/$/, "").split("/").filter(Boolean);
}
function hasClassDetailSuffix(pathname) {
    const segments = pathSegments(pathname);
    return segments.length >= 2 && segments[segments.length - 2]?.toLowerCase() === "classes";
}
function applicationBase(pathname) {
    const trimmed = pathname.replace(/\/$/, "");
    const segment = routeSegment(pathname);
    const suffixLength = hasClassDetailSuffix(pathname)
        ? `classes/${segment}`.length
        : isRouteSegment(segment)
            ? segment.length
            : 0;
    const base = suffixLength > 0 ? trimmed.slice(0, -suffixLength) : `${trimmed}/`;
    return base.startsWith("/") ? base : `/${base}`;
}
export function routeFromPathname(pathname) {
    if (hasClassDetailSuffix(pathname))
        return "classDetail";
    const segment = routeSegment(pathname);
    return isRouteSegment(segment) ? segment : "home";
}
export function hrefForRoute(pathname, route) {
    const base = applicationBase(pathname);
    if (route === "classDetail")
        return `${base}classes`;
    return route === "home" ? base : `${base}${route}`;
}
export function classDetailHref(pathname, classId) {
    return `${applicationBase(pathname)}classes/${encodeURIComponent(classId)}`;
}
export function classIdFromPathname(pathname) {
    return hasClassDetailSuffix(pathname) ? decodeURIComponent(routeSegment(pathname)) : null;
}
export function bookingClassIdFromSearch(search) {
    return new URLSearchParams(search).get("class");
}
